import { ReferralsPage } from "./admin/pages/ReferralsPage";
import { createHashRouter, Navigate, RouterProvider } from "react-router-dom";
import App from "./App";
import { StartPage } from "./pages/StartPage";
import { MissionPage } from "./pages/MissionPage";
import { VideoPage } from "./pages/VideoPage";
import { ArtSearchPage } from "./pages/ArtSearchPage";
import { ArtPage } from "./pages/ArtPage";
import { HelpPage } from "./pages/HelpPage";
import { ImpressumPage } from "./pages/ImpressumPage";
import { AGBPage } from "./pages/AGBPage";
import { DatenschutzPage } from "./pages/DatenschutzPage";
import { CookiesPolicyPage } from "./pages/CookiesPolicyPage";
import { ThankyouPage } from "./pages/ThankyouPage";
import { ContactPage } from "./pages/ContactPage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ProfilePage } from "./pages/ProfilePage";
import { CartPage } from "./pages/CartPage";
import { PaymentPage } from "./pages/PaymentPage";
import { PaymentSuccessPage } from "./pages/PaymentSuccessPage";
import { WorldPage } from "./pages/WorldPage";
import { AdminLayout } from "./admin/AdminLayout";
import { DashboardPage } from "./admin/pages/DashboardPage";
import { UsersPage } from "./admin/pages/UsersPage";
import { RegionsPage } from "./admin/pages/RegionsPage";
import { PixelsPage } from "./admin/pages/PixelsPage";
import { ContactsPage } from "./admin/pages/ContactsPage";

// We use a hash router instead of the browser history API so the URLs match
// the legacy site (e.g. https://dwik.art/#world). That also means the SPA
// can be hosted on any static server without needing a catch-all redirect.
const router = createHashRouter([
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="/admin/dashboard" replace /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "regions", element: <RegionsPage /> },
      { path: "pixels", element: <PixelsPage /> },
      { path: "contacts", element: <ContactsPage /> },
      { path: "referrals", element: <ReferralsPage /> },
      { path: "*", element: <Navigate to="/admin/dashboard" replace /> },
    ],
  },
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/start" replace /> },
      { path: "start", element: <StartPage /> },
      { path: "mission", element: <MissionPage /> },
      { path: "video", element: <VideoPage /> },
      { path: "art", element: <ArtPage /> },
      { path: "art-search", element: <ArtSearchPage /> },
      { path: "help", element: <HelpPage /> },
      { path: "impressum", element: <ImpressumPage /> },
      { path: "agb", element: <AGBPage /> },
      { path: "datenschutz", element: <DatenschutzPage /> },
      { path: "cookies-policy", element: <CookiesPolicyPage /> },
      { path: "thankyou", element: <ThankyouPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "login", element: <LoginPage /> },
      { path: "register", element: <RegisterPage /> },
      { path: "profile", element: <ProfilePage /> },
      { path: "cart", element: <CartPage /> },
      { path: "payment", element: <PaymentPage /> },
      { path: "payment-success", element: <PaymentSuccessPage /> },
      { path: "world", element: <WorldPage /> },
      { path: "*", element: <Navigate to="/start" replace /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
